import { render, staticRenderFns } from "./CardAreas.vue?vue&type=template&id=e02a527e"
import script from "./CardAreas.vue?vue&type=script&lang=js"
export * from "./CardAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports